// src/lib/format.js

/** Kwota po polsku: 149 zł, 12,71 zł - bez zbędnych zer po przecinku. */
export const formatPln = value => {
  const amount = Number(value) || 0;
  const hasFraction = Math.round(amount * 100) % 100 !== 0;
  return `${amount.toFixed(hasFraction ? 2 : 0).replace('.', ',')} zł`;
};

/** Ścieżka do awatara użytkownika.
 *  Backend zwraca raz samą nazwę ("my-photo"), a raz nazwę z rozszerzeniem
 *  ("my-photo.webp"), więc doklejanie ".webp" w komponencie dawało
 *  "/my-photo.webp.webp" i 404. Jedno miejsce prawdy dla obu wariantów. */
export const processImagePath = image => {
  const nazwa = image || 'my-photo';
  const rawImage = nazwa.startsWith('/') ? nazwa : `/${nazwa}`;
  return rawImage.endsWith('.webp') ? rawImage : `${rawImage}.webp`;
};
